<div class="report-page-root-container master-sales-report-cost-component-container">
  <div class="page-content">
    <div class="page-header">
      <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" id="volume-analysis" style="width:27px">
        <path
          d="M7,25.08H5V13a3,3,0,0,1,3-3H23v2H8a1,1,0,0,0-1,1ZM45,38H43V29H41v9H7V35H21V33H3v2H5v3H3a1,1,0,0,0-1,1v2a5,5,0,0,0,5,5H41a5,5,0,0,0,5-5V39A1,1,0,0,0,45,38ZM24,10H46V25a3,3,0,0,1-3,3H27a3,3,0,0,1-3-3Zm5,5H41V13H29Zm0,4H41V17H29Zm0,4H41V21H29ZM46,5V8H24V5a3,3,0,0,1,3-3H43A3,3,0,0,1,46,5ZM31,4H28V6h3Zm5,0H33V6h3ZM11,27a1,1,0,0,0-1-1H6a1,1,0,0,0-1,1v5h6Zm3-6a1,1,0,0,0-1,1V32h6V22a1,1,0,0,0-1-1Z"
          data-name="33 Volume Analysis, Bar Chart, Bar Graph, Column Graph, Graphical Representation">
        </path>
      </svg> -->
      <img class="icon" src="assets/images/menu/svg/hourly-sales-report.svg" width="27" />
      <div class="title">
        {{ title }}
      </div>
      <div class="action-btn-container">
        @if(permission.can_export || permission.can_execute){
        <button mat-button color="accent" class="action-btn btn-export" (click)="exportClicked()"
          [disabled]="IsDownloading">
          <img class="download-icon"
            [src]="IsDownloading ? 'assets/images/animated/download/download-anim.svg' : 'assets/images/animated/download/download-no-anim.svg'">
          <span class="action-btn-title">Export</span>
        </button>
        }
        <!-- <button mat-flat-button class="action-btn btn-save" (click)="navigateToWeeklyReport()">View</button> -->
      </div>
    </div>
    <div class="page-details">
      <form class="edit-form" [formGroup]="editForm">
        <div class="detail-section">
          <div class="content-container">
            <div class="row">
              <mat-form-field>
                <mat-label>Period From</mat-label>
                <input matInput [matDatepicker]="pickerFrom" formControlName="period_from" placeholder="DD-MM-YYYY" />
                <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                <mat-datepicker #pickerFrom></mat-datepicker>
                <mat-error
                  *ngIf="editForm.get('period_from')?.hasError('required') && editForm.get('period_from')?.touched">
                  Please select a date.
                </mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Period To</mat-label>
                <input matInput [matDatepicker]="pickerTo" formControlName="period_to"
                  [min]="editForm.get('period_from')?.value" placeholder="DD-MM-YYYY" />
                <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
                <mat-datepicker #pickerTo></mat-datepicker>
                <mat-error
                  *ngIf="editForm.get('period_to')?.hasError('required') && editForm.get('period_to')?.touched">
                  Please select a date.
                </mat-error>
              </mat-form-field>
            </div>
            <!-- Order Source Dropdown -->
            <div class="list-row order-source">
              <div class="header" (click)="isExpandedOrder = !isExpandedOrder">
                <div class="title-container" >
                  <span class="title">Order Source</span>
                  <span class="count" *ngIf="selectedOrderSourcesCount > 0">
                    [ {{selectedOrderSourcesCount}} ]
                  </span>
                </div>
                <div class="toggle-action-container">
                  <button *ngIf="isExpandedOrder" class="list-action-button"
                    (click)="showSelectedOrderSourceOnly = !showSelectedOrderSourceOnly"
                    [matTooltip]="showSelectedOrderSourceOnly ? 'Show All' : 'Show Selected Only'">
                    <mat-icon>{{ showSelectedOrderSourceOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                  <button *ngIf="isExpandedOrder" class="list-action-button" (click)="toggleSelectAllOrderSource()"
                    matTooltip="Select All/None">
                    <mat-icon>{{ getSelectAllIconOrderSource() }}</mat-icon>
                  </button>
                  <button class="list-action-button" (click)="isExpandedOrder = !isExpandedOrder">
                    <mat-icon>{{ isExpandedOrder ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>
                </div>
              </div>
              <div *ngIf="isExpandedOrder" class="list">
                <div class="item-list">
                  <div class="content-filter">
                    <mat-form-field style="width: 100%;" class="hide-subscript-wrapper">
                      <input matInput placeholder="Filter Order Source" formControlName="orderSourceFilter">
                      <button *ngIf="editForm.get('orderSourceFilter')?.value" matSuffix mat-icon-button
                        aria-label="Clear" (click)="editForm.get('orderSourceFilter')?.setValue('')">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  <div class="content">
                    <ng-container *ngFor="let item of filteredOrderSourceListData">
                      <div class="list-item"
                        (click)="item.selected = !item.selected; onListSelectionChange('orderSource')">
                        <div class="name"><span>{{item.item.name}}</span></div>
                        <div class="selection">
                          <mat-checkbox [checked]="item.selected"
                            (change)="item.selected = !item.selected; onListSelectionChange('orderSource')"
                            (click)="$event.stopPropagation()">
                          </mat-checkbox>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <!-- Terminal Dropdown -->
            <div class="list-row terminals">
              <div class="header" (click)="isExpandedTerminal = !isExpandedTerminal">
                <div class="title-container" >
                  <span class="title">Terminal</span>
                  <span class="count" *ngIf="selectedTerminalSourcesCount > 0">
                    [ {{selectedTerminalSourcesCount}} ]
                  </span>
                </div>
                <div class="toggle-action-container">
                  <button *ngIf="isExpandedTerminal" class="list-action-button"
                    (click)="showSelectedTerminalOnly = !showSelectedTerminalOnly"
                    [matTooltip]="showSelectedTerminalOnly ? 'Show All' : 'Show Selected Only'">
                    <mat-icon>{{ showSelectedTerminalOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                  <button *ngIf="isExpandedTerminal" class="list-action-button" (click)="toggleSelectAllTerminal()"
                    matTooltip="Select All/None">
                    <mat-icon>{{ getSelectAllIconTerminal() }}</mat-icon>
                  </button>
                  <button class="list-action-button" (click)="isExpandedTerminal = !isExpandedTerminal">
                    <mat-icon>{{ isExpandedTerminal ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>
                </div>
              </div>
              <div *ngIf="isExpandedTerminal" class="list">
                <div class="item-list">
                  <div class="content-filter">
                    <mat-form-field style="width: 100%;" class="hide-subscript-wrapper">
                      <input matInput placeholder="Filter Terminal" formControlName="terminalFilter">
                      <button *ngIf="editForm.get('terminalFilter')?.value" matSuffix mat-icon-button aria-label="Clear"
                        (click)="editForm.get('terminalFilter')?.setValue('')">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  <div class="content">
                    <ng-container *ngFor="let item of filteredTerminalListData">
                      <div class="list-item"
                        (click)="item.selected = !item.selected; onListSelectionChange('terminal')">
                        <div class="name"><span>{{item.item.name}}</span></div>
                        <div class="selection">
                          <mat-checkbox [checked]="item.selected"
                            (change)="item.selected = !item.selected; onListSelectionChange('terminal')"
                            (click)="$event.stopPropagation()">
                          </mat-checkbox>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <!-- Cashier Dropdown -->
            <div class="list-row cashier">
              <div class="header" (click)="isExpandedCashier = !isExpandedCashier">
                <div class="title-container" >
                  <span class="title">Cashier</span>
                  <span class="count" *ngIf="selectedCasheirSourcesCount > 0">
                    [ {{selectedCasheirSourcesCount}} ]
                  </span>
                </div>
                <div class="toggle-action-container">
                  <button *ngIf="isExpandedCashier" class="list-action-button"
                    (click)="showSelectedCashierOnly = !showSelectedCashierOnly"
                    [matTooltip]="showSelectedCashierOnly ? 'Show All' : 'Show Selected Only'">
                    <mat-icon>{{ showSelectedCashierOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                  <button *ngIf="isExpandedCashier" class="list-action-button" (click)="toggleSelectAllCashier()"
                    matTooltip="Select All/None">
                    <mat-icon>{{ getSelectAllIconCashier() }}</mat-icon>
                  </button>
                  <button class="list-action-button" (click)="isExpandedCashier = !isExpandedCashier">
                    <mat-icon>{{ isExpandedCashier ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>
                </div>
              </div>
              <div *ngIf="isExpandedCashier" class="list">
                <div class="item-list">
                  <div class="content-filter">
                    <mat-form-field style="width: 100%;" class="hide-subscript-wrapper">
                      <input matInput placeholder="Filter Cashier" formControlName="cashierFilter">
                      <button *ngIf="editForm.get('cashierFilter')?.value" matSuffix mat-icon-button aria-label="Clear"
                        (click)="editForm.get('cashierFilter')?.setValue('')">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  <div class="content">
                    <ng-container *ngFor="let item of filteredCashierListData">
                      <div class="list-item" (click)="item.selected = !item.selected; onListSelectionChange('cashier')">
                        <div class="name"><span>{{item.item.name}}</span></div>
                        <div class="selection">
                          <mat-checkbox [checked]="item.selected"
                            (change)="item.selected = !item.selected; onListSelectionChange('cashier')"
                            (click)="$event.stopPropagation()">
                          </mat-checkbox>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <!-- Main Group Dropdown -->
            <div class="list-row main-group">
              <div class="header" (click)="isExpandedMainGroup = !isExpandedMainGroup">
                <div class="title-container" >
                  <span class="title">Main Group</span> <span class="count" *ngIf="selectedMainGroupSourcesCount > 0">[
                    {{selectedMainGroupSourcesCount}} ] </span>
                </div>
                <div class="toggle-action-container">
                  <button *ngIf="isExpandedMainGroup" class="list-action-button"
                    (click)="showSelectedMainGroupOnly = !showSelectedMainGroupOnly"
                    [matTooltip]="showSelectedMainGroupOnly ? 'Show All' : 'Show Selected Only'">
                    <mat-icon>{{ showSelectedMainGroupOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                  <button *ngIf="isExpandedMainGroup" class="list-action-button" (click)="toggleSelectAllMainGroup()"
                    matTooltip="Select All/None">
                    <mat-icon>{{ getSelectAllIconMainGroup() }}</mat-icon>
                  </button>
                  <button class="list-action-button" (click)="isExpandedMainGroup = !isExpandedMainGroup">
                    <mat-icon>{{ isExpandedMainGroup ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>
                </div>
              </div>
              <div *ngIf="isExpandedMainGroup" class="list">
                <div class="item-list">
                  <div class="content-filter">
                    <mat-form-field style="width: 100%;" class="hide-subscript-wrapper">
                      <input matInput placeholder="Filter Main Group" formControlName="mainGroupFilter">
                      <button *ngIf="editForm.get('mainGroupFilter')?.value" matSuffix mat-icon-button
                        aria-label="Clear" (click)="editForm.get('mainGroupFilter')?.setValue('')">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  <div class="content">
                    <ng-container *ngFor="let item of filteredMainGroupListData">
                      <div class="list-item"
                        (click)="item.selected = !item.selected; onListSelectionChange('mainGroup')">
                        <div class="name"><span>{{item.item.name}}</span></div>
                        <div class="selection">
                          <mat-checkbox [checked]="item.selected"
                            (change)="item.selected = !item.selected; onListSelectionChange('mainGroup')"
                            (click)="$event.stopPropagation()">
                          </mat-checkbox>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <!-- Group Dropdown -->
            <div class="list-row group-form">
              <div class="header" (click)="isExpandedGroup = !isExpandedGroup">
                <div class="title-container" >
                  <span class="title">Group</span> <span class="count" *ngIf="selectedGroupSourcesCount > 0">
                    [ {{selectedGroupSourcesCount}} ]
                  </span>
                </div>
                <div class="toggle-action-container">
                  <button *ngIf="isExpandedGroup" class="list-action-button"
                    (click)="showSelectedGroupOnly = !showSelectedGroupOnly"
                    [matTooltip]="showSelectedGroupOnly ? 'Show All' : 'Show Selected Only'">
                    <mat-icon>{{ showSelectedGroupOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                  <button *ngIf="isExpandedGroup" class="list-action-button" (click)="toggleSelectAllGroup()"
                    matTooltip="Select All/None">
                    <mat-icon>{{ getSelectAllIconGroup() }}</mat-icon>
                  </button>
                  <button class="list-action-button" (click)="isExpandedGroup = !isExpandedGroup">
                    <mat-icon>{{ isExpandedGroup ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>
                </div>
              </div>
              <div *ngIf="isExpandedGroup" class="list">
                <div class="item-list">
                  <div class="content-filter">
                    <mat-form-field style="width: 100%;" class="hide-subscript-wrapper">
                      <input matInput placeholder="Filter Group" formControlName="groupFilter">
                      <button *ngIf="editForm.get('groupFilter')?.value" matSuffix mat-icon-button aria-label="Clear"
                        (click)="editForm.get('groupFilter')?.setValue('')">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  <div class="content">
                    <ng-container *ngFor="let item of filteredGroupListData">
                      <div class="list-item" (click)="item.selected = !item.selected; onListSelectionChange('group')">
                        <div class="name"><span>{{item.item.name}}</span></div>
                        <div class="selection">
                          <mat-checkbox [checked]="item.selected"
                            (change)="item.selected = !item.selected; onListSelectionChange('group')"
                            (click)="$event.stopPropagation()">
                          </mat-checkbox>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <!-- Item Dropdown -->
            <!-- Item Dropdown -->
            <div class="list-row item">
              <div class="header" (click)="isExpandedItem = !isExpandedItem">
                <div class="title-container" >
                  <span class="title">Item</span> <span class="count" *ngIf="selectedItemSourcesCount > 0">
                    [ {{selectedItemSourcesCount}} ]
                  </span>
                </div>
                <div class="toggle-action-container">
                  <button *ngIf="isExpandedItem" class="list-action-button"
                    (click)="showSelectedItemOnly = !showSelectedItemOnly"
                    [matTooltip]="showSelectedItemOnly ? 'Show All' : 'Show Selected Only'">
                    <mat-icon>{{ showSelectedItemOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                  <button *ngIf="isExpandedItem" class="list-action-button" (click)="toggleSelectAllItem()"
                    matTooltip="Select All/None">
                    <mat-icon>{{ getSelectAllIconItem() }}</mat-icon>
                  </button>
                  <button class="list-action-button" (click)="isExpandedItem = !isExpandedItem">
                    <mat-icon>{{ isExpandedItem ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>
                </div>
              </div>
              <div *ngIf="isExpandedItem" class="list">
                <div class="item-list">
                  <div class="content-filter">
                    <mat-form-field style="width: 100%;" class="hide-subscript-wrapper">
                      <input matInput placeholder="Filter Item" formControlName="itemFilter">
                      <button *ngIf="editForm.get('itemFilter')?.value" matSuffix mat-icon-button aria-label="Clear"
                        (click)="editForm.get('itemFilter')?.setValue('')">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  <div class="content">
                    <ng-container *ngFor="let item of filteredItemListData">
                      <div class="list-item" (click)="item.selected = !item.selected; onListSelectionChange('item')">
                        <div class="name"><span>{{item.item.name}}</span></div>
                        <div class="selection">
                          <mat-checkbox [checked]="item.selected"
                            (change)="item.selected = !item.selected; onListSelectionChange('item')"
                            (click)="$event.stopPropagation()">
                          </mat-checkbox>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <!-- Sort Order -->
            
              
                <div class="row">
                  <mat-form-field appearance="fill" >
                    <mat-label>Sort By</mat-label>
                    <mat-select formControlName="sortBy">
                      <mat-option value="qty_total">Qty Sold</mat-option>
                      <mat-option value="sub_total">Amount Sold</mat-option>
                      <mat-option value="gp">Gross Profit</mat-option>
                    </mat-select>
                  </mat-form-field>
                    <mat-form-field appearance="fill" >
                    <mat-label>Order</mat-label>
                    <mat-select formControlName="orderBy">
                      <mat-option value="asc">Ascending</mat-option>
                      <mat-option value="desc">Descending</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
               

            <mat-checkbox formControlName="includeCos">
              Include Cost
            </mat-checkbox>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>